import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';

// ----------------------------------------------------------------------

type TargetComboInputProps = Readonly<{
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  onClear: () => void;
  error?: string;
  isLoading: boolean;
  isResolved: boolean;
  resolvedComboName: string;
}>;

export function TargetComboInput({
  value,
  onChange,
  onBlur,
  onClear,
  error,
  isLoading,
  isResolved,
  resolvedComboName,
}: TargetComboInputProps) {
  return (
    <Box sx={{ pl: 4, pb: 2 }}>
      <TextField
        label="Combo ID"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        size="small"
        data-testid="combo-id-input"
        error={!!error}
        helperText={error}
        sx={{ width: 220 }}
        slotProps={{
          htmlInput: { maxLength: 7, inputMode: 'numeric', pattern: '[0-9]*' },
          input: {
            endAdornment: value ? (
              <InputAdornment position="end">
                {isLoading ? (
                  <CircularProgress size={16} />
                ) : (
                  <IconButton size="small" onClick={onClear} aria-label="clear">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </InputAdornment>
            ) : null,
          },
        }}
      />

      {isResolved && (
        <Box sx={{ mt: 1.5 }} data-testid="existing-target-resolved">
          <Typography variant="caption" color="text.secondary">
            Combo ID
          </Typography>
          <Typography variant="body2" fontWeight={500}>
            {value}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.75, display: 'block' }}>
            Combo name
          </Typography>
          <Typography variant="body2" fontWeight={500}>
            {resolvedComboName}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
